<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						競技場對手名次計算
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title mb-4">
					競技場對手名次計算
				</h3>
				<div class="item-content collapse show multi-collapse" id="rank_reward">
					<div class="form-row align-items-center mb-3">
						<div class="col-md-12 mb-3">
							<label for="RankNow">現在Rank</label>
							<div class="input-group">
								<input type="number" class="form-control" id="RankNow" v-model="nowRank" onclick="this.select();">
							</div>
						</div>
						<div class="col-md-12 mb-3">
							<h6>
								最高對手排名列表(大約吧)
							</h6>
							<template v-for="(item,index) in calculate"> 
								<span style="font-size: 16px; width: 95px" class="badge badge-success px-4 py-2 m-2">{{item.rank}} </span>
								<div class="d-inline-block" v-if="(index+1) % 5 != 0 && maxTime != (index+1)"> > </div>
								<hr class="d-block w-100" v-if="(index+1) % 5 == 0" />
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ArenaFindRank',
	metaInfo: {
		title: '競技場對手名次表',
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '競技場對手名次表' }
		]
	},
	data() {
		return {
			nowRank: 15001,
			maxTime: 0,
		}
	},
	methods: {

	},
	created: function() {},
	computed: {
		calculate: function() {
			var self = this;
			var nowRank = { "rank": self.nowRank };
			var allPath = new Array();
			var nextRank = Number(nowRank.rank);
			do {
				if (nextRank <= 11) {
					nextRank = 1;
				} else if (nextRank > 10 && nextRank <= 69) {
					nextRank = nextRank - 10;
				} else {
					nextRank = Math.floor(nextRank * 0.85);
				}
				var nextRankObj = { "rank": nextRank };
				allPath.push(nextRankObj);

			}
			while (nextRank > 1)
			self.maxTime = allPath.length;
			return allPath;
		},
	},
	mounted: function() {}
}

</script>
<style scoped>
</style>
